import request from '@/utils/request'
// 分页查询工作量统计
export function logpage(data) {
  return request({
    url: 'log/page',
    method: 'post',
    data: data
  })
}

// 分页查询详细操作记录
export function detailPage(data) {
  return request({
    url: 'log/detailPage',
    method: 'post',
    data: data
  })
}

// 查询材料
export function configlist(info) {
  return request({
    url: 'sys/config/list',
    method: 'post',
    data: info
  })
}
